<template>
  <div>
    <div class="mt-3 period-selector">
      <b-button-group>
        <span v-for="(intervalButton, index) in intervalButtons" :key="'intervalButton-' + index">
          <b-button
              class="internal-button"
              :variant="intervalButton.active ? 'active' : ''"
              @click="changeInterval(intervalButton)"
              :key="updateKey"
          >
            {{ $cte(intervalButton.label) }}
          </b-button>
        </span>
      </b-button-group>
    </div>
    <b-overlay class="mt-3 mb-3">
      <span
          class="period-label font-poppins"> A NAV Online számla adatok alapján az alábbi forgalmat jelezzük előre. </span>
      <div class="d-flex flex-row align-items-center align-items-stretch mt-3 reportSliderContainer">
        <div class="paging-div mr-4 desktop-only" @click="pageLeft">
          <i class="fas fa-angle-left"></i>
        </div>
        <div class="mt-4 relative w-100">
          <div class="justify-content-center spacing mb-4 desktop-only">
            <div v-if="activeInterval === 'yearly'" class="title">{{ yearPointer }}</div>
            <div v-if="activeInterval === 'quarterly'" class="title">{{ yearPointer }}
              {{ hungarianQuarters[quarterPointer] }}
            </div>
            <div v-if="activeInterval === 'monthly'" class="title">{{ yearPointer }}
              {{ hungarianMonths[monthPointer] }}
            </div>
          </div>

          <div class="mobile-only">
            <div class="d-flex flex-row align-items-center spacing-2 card-container">
              <div class="paging-div mr-4 py-3" @click="pageLeft">
                <i class="fas fa-angle-left"></i>
              </div>
              <div class="mt-4 relative container-style">
                <div class="d-flex justify-content-center spacing mb-4">
                  <div v-if="activeInterval === 'yearly'" class="title">{{ yearPointer }}</div>
                  <div v-if="activeInterval === 'quarterly'" class="title">{{ yearPointer }}
                    {{ hungarianQuarters[quarterPointer] }}
                  </div>
                  <div v-if="activeInterval === 'monthly'" class="title">{{ yearPointer }}
                    {{ hungarianMonths[monthPointer] }}
                  </div>
                </div>
              </div>
              <div
                  class="paging-div ml-4 py-3"
                  @click="pageRight"
              >
                <i class="fas fa-angle-right"></i>
              </div>
            </div>
          </div>

          <b-container class="text-style min-width" v-if="mode === 'vat' && !error">
            <b-row>
              <b-col sm="12" lg="6" class="p-0">
                <span class="text-style list-item">Fizetendő ÁFA</span>
              </b-col>
              <b-col class="text-left text-lg-right p-0" sm="12" lg="6">
              <span class="text-style text-lg-right list-item">{{
                  Number(payableVat).toLocaleString("hu-HU") + " Ft"
                }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="6" class="p-0">
                <span class="text-style list-item">Levonható ÁFA</span>
              </b-col>
              <b-col class="text-left text-lg-right p-0" sm="12" lg="6">
              <span class="text-style text-lg-right list-item">{{
                  Number(deductibleVat).toLocaleString("hu-HU") + " Ft"
                }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="6" class="p-0">
                <span class="text-style-bold list-item">Tárgyidőszaki egyenleg</span>
              </b-col>
              <b-col sm="12" lg="6" class="text-left text-lg-right p-0">
              <span class="text-style-bold text-lg-right list-item">{{
                  Number(balance).toLocaleString("hu-HU") + " Ft"
                }}</span>
              </b-col>
            </b-row>
            <div class="my-4"/>
          </b-container>
          <div v-else-if="error" class="min-width">
            <span class="list-item">{{ error }}</span>
            <div class="my-4"/>
          </div>
          <b-container class="text-style min-width" v-else-if="mode === 'transactions' && !error ">
            <b-row>
              <b-col sm="12" lg="6" class="p-0">
                <span class="text-style-bold list-item">Forgalom</span>
              </b-col>
              <b-col sm="12" lg="6" class="text-left text-lg-right p-0">
              <span class="text-style-bold text-lg-right list-item">{{
                  Number(amount).toLocaleString("hu-HU") + " Ft"
                }}</span>
              </b-col>
            </b-row>
            <div class="my-4"/>
          </b-container>
        </div>
        <div
            class="paging-div ml-4 desktop-only"
            @click="pageRight"
        >
          <i class="fas fa-angle-right"></i>
        </div>
      </div>
    </b-overlay>
    <div class="period-label font-poppins" v-if="mode === 'vat'">
      Ne feledd, a fizetendő ÁFA az előző időszaki áthozat és az ÁFA törvény szabályainak függvényében változhat.
    </div>
    <div class="d-flex flex-row align-items-center justify-content-end bottom-right-container" v-if="!navNotFound">
      <p class="description-text mt-3 mr-3" v-if="navData.lastStatus === 'PENDING' || navData.lastStatus === 'CREATED'">
        A frissítés befejezéséig türelmedet kérjük!
      </p>
      <p class="description-text mt-3 mr-3" v-else-if="navData.lastStatus === 'SUCCESS'">
        {{ $cte("vat.lastUpdate") }}:
        {{ $moment(new Date(navData.lastRefreshDate)).format("YYYY. MM. DD HH:mm") }}
      </p>
      <p class="description-text mt-3 mr-3" v-else-if="navData.lastStatus === 'FAILED'">
        {{ $cte("A legutolsó frissités hibára futott: ") }}:
        {{ $moment(new Date(navData.lastRefreshDate)).format("YYYY. MM. DD HH:mm") }}
      </p>
      <div class="d-flex align-items-center">
        <b-button variant="light" @click="updateLastUpdatedDate" :disabled="!navData.canBeStarted">
          <i class="fas fa-history mt-1"></i>
          <span class="d-inline-block ml-2 mt-1">{{
              $cte("vat.update")
            }}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "api-client";
import {mapGetters} from "vuex";

export default {
  name: "VatView",
  components: {},
  props: {
    vatOption: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      vatData: null,
      lastUpdate: null,
      error: null,
      currentYear: new Date().getFullYear(),
      yearPointer: new Date().getFullYear(),
      quarterPointer:
          new Date().getMonth() % 3,
      monthPointer: new Date().getMonth(),
      payableVat: null,
      deductibleVat: null,
      balance: null,
      amount: null,
      navData: null,
      navNotFound: false,
      intervalButtons: [
        {
          label: "vat.monthly",
          active: true,
          value: "monthly",
        },
        {
          label: "vat.quarterly",
          active: false,
          value: "quarterly",
        },
        {
          label: "vat.annual",
          active: false,
          value: "yearly",
        },
      ],
      activeInterval: "monthly",
      hungarianMonths: [
        "január",
        "február",
        "március",
        "április",
        "május",
        "június",
        "július",
        "augusztus",
        "szeptember",
        "október",
        "november",
        "december"
      ],
      hungarianQuarters: [
        "I. negyedév",
        "II. negyedév",
        "III. negyedév",
        "IV. negyedév"
      ],
      updateKey: 0
    };
  },
  methods: {
    changeInterval(intervalData) {
      this.intervalButtons.forEach((button) => {
        button.active = false;
      });

      this.activeInterval = intervalData.value;
      this.intervalButtons.forEach((button) => {
        if (button.value === intervalData.value) {
          button.active = true
        }
      });

      this.yearPointer = new Date().getFullYear(),
          this.quarterPointer = new Date().getMonth() % 3,
          this.monthPointer = new Date().getMonth(),
          this.updateKey++;

      this.getVats();
    },

    updateVATData() {
      let self = this;

      self.loading = true;

      let params = {
        companyId: self.getActiveCompany.id,
      };

      Api.updateVats(params)
          .then(() => {
            self.$toast.success({
              title: this.$cte("common.success"),
              message: this.$cte("nav.updateVatsSuccess"),
            });

            self.getVats(false);

            self.loading = false;
          })
          .catch(() => {
            self.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("nav.updateVatsFailed"),
            });

            self.loading = false;
          });
    },

    validateVatData() {
      let self = this;
      Api.getNavTechnicalUser(this.getActiveCompany.id)
          .then((resp) => {
            if (resp.data.userSignatureKey) {
              self.$emit("validate", true);
            } else {
              self.$emit("validate", false);
            }
          })
          .catch((err) => {
            self.$emit("validate", true);
            console.error(err);
          });
    },

    getVats() {
      this.loading = true;

      if (this.mode === "vat") {
        Api.getTaxOfACompany(
            this.getActiveCompany.id,
            this.yearPointer,
            this.activeInterval === 'quarterly' ? this.quarterPointer : null,
            this.activeInterval === 'monthly' ? this.monthPointer : null)
            .then((resp) => {

              this.payableVat = resp.data.payableVat
              this.deductibleVat = resp.data.deductibleVat
              this.balance = resp.data.balance
              this.error = null;
              this.loading = false;
            })
            .catch((err) => {
              this.error = err.response.data.message;
              this.loading = false;
            });
      }
      if (this.mode === "transactions") {
        Api.getOnlyIncome(
            this.getActiveCompany.id,
            this.yearPointer,
            this.activeInterval === 'quarterly' ? this.quarterPointer : null,
            this.activeInterval === 'monthly' ? this.monthPointer : null)
            .then((resp) => {
              this.amount = resp.data;
              this.error = null;
              this.loading = false;
            })
            .catch((err) => {
              this.error = err.response.data.message;
              this.loading = false;

            });
      }

    },

    updateNavData() {
      // Itt egy olyan Api hivas volt ami mindig hibara futott, ott meg ez volt ¯\\(ツ)/¯
      this.navNotFound = true;
      this.navLoading = false;
    },
    updateLastUpdatedDate() {
      Api.manualUpdateNav(this.getActiveCompany.id).then(() => {
        this.updateNavData();
      }).catch((err) => {
        console.log(err);
      })
    },
    currencyFormatter(value) {
      let formatter = new Intl.NumberFormat("hu-HU");

      return formatter.format(value);
    },

    parseDate(data, enableTime = true) {
      let d = new Date(data),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear(),
          hours = d.getHours(),
          minutes = d.getMinutes();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      if (hours.length < 2) hours = "0" + hours;
      if (minutes.length < 2) minutes = "0" + minutes;

      if (enableTime) {
        return [year, month, day].join("-") + " " + [hours, minutes].join(":");
      } else {
        return [year, month, day].join("-");
      }
    },

    getChartLabel() {
      let labelArray = [];

      let self = this;

      if (!!self.vatData && self.vatData.length > 0) {
        self.vatData.forEach((vatItem) => {
          labelArray.push(self.parseDate(vatItem.date, false));
        });
      }

      return labelArray;
    },

    getChartData() {
      let dataArray = [];

      let self = this;

      if (!!self.vatData && self.vatData.length > 0) {
        self.vatData.forEach((vatItem) => {
          dataArray.push(vatItem[self.vatOption.value]);
        });
      }

      return dataArray;
    },
    pageLeft() {
      if (this.activeInterval === "monthly") {
        if (this.monthPointer <= 0) {
          this.yearPointer = this.yearPointer - 1;
          this.monthPointer = 11;
        } else {
          this.monthPointer = this.monthPointer - 1;
        }
      }

      if (this.activeInterval === "quarterly") {
        if (this.quarterPointer <= 0) {
          this.yearPointer = this.yearPointer - 1;
          this.quarterPointer = 3;
        } else {
          this.quarterPointer = this.quarterPointer - 1;
        }
      }

      if (this.activeInterval === "yearly") {
        this.yearPointer = this.yearPointer - 1;
      }
      this.getVats();

    },

    pageRight() {
      if (this.activeInterval === "monthly") {
        if (this.currentYear === this.yearPointer && this.monthPointer >= 11) {
          return;
        }

        if (this.monthPointer >= 11) {
          this.yearPointer = this.yearPointer + 1;
          this.monthPointer = 0;
        } else {
          this.monthPointer = this.monthPointer + 1;
        }
      }

      if (this.activeInterval === "quarterly") {
        if (this.currentYear === this.yearPointer && this.quarterPointer >= 3) {
          return;
        }

        if (this.quarterPointer >= 3) {
          this.yearPointer = this.yearPointer + 1;
          this.quarterPointer = 0;
        } else {
          this.quarterPointer = this.quarterPointer + 1;
        }
      }
      if (this.activeInterval === "yearly") {
        if (this.currentYear === this.yearPointer) {
          return;
        }
        this.yearPointer = this.yearPointer + 1;
      }
      this.getVats();

    },
  },
  mounted() {
    this.changeInterval(this.intervalButtons[0])
  },
  created() {
    this.getVats()
    this.updateNavData();
    this.validateVatData();
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),

    chartDataSet() {
      return {
        labels: this.getChartLabel(),
        datasets: [
          {
            label: "Data 1",
            data: this.getChartData(),
            backgroundColor: "transparent",
            borderColor: "#5bb65d",
            pointBackgroundColor: "#5bb65d",
          },
        ],
      };
    },

    vatSum() {
      let self = this;
      let sum = 0;

      if (!!self.vatData && self.vatData.length > 0) {
        self.vatData.forEach((vatItem) => {
          sum = vatItem[self.vatOption.value];
        });
      }

      return sum;
    },
  },
  watch: {
    vatOption: {
      handler: function () {
        let self = this;
        setTimeout(function () {
          self.$refs["lineChart"].refreshChart();
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  margin-left: auto;
  margin-right: auto;
  max-width: 628px;

  button {
    border-radius: 0;
    flex-grow: 1;
    flex-basis: 0;

    &:first-child {
      border-top-left-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
    }

    &:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
  }
}

.description-text {
  color: #b5b5c3;
}

.vat-sum {
  font-size: 42px;
  font-weight: 600;
}

.internal-button {
  min-width: 100%;
}

.period-selector {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: #252734;
  border-radius: 32px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.period-selector::-webkit-scrollbar {
  display: none;
}

.period-selector >>> .btn-group {
  display: inline-flex;
  flex-wrap: nowrap;
  min-width: max-content;
}

.period-selector >>> .btn-group > span,
.period-selector >>> .btn-group .btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

.custom-padding {
  padding: 0.2rem;
}


/* Remove padding again on lg viewport */
@media (min-width: 992px) {
  .custom-padding {
    padding: 0;
  }
}

.period-label {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.52);
}

hr {
  border: none;
  border-top: 10px solid #ABD6A6;
  margin: 20px 0 0 0;
}

.card-body {
  width: 100%;
  padding-left: 4rem !important;
  padding-right: 4rem !important;
  margin: 0 auto;
}

.title {
  font-family: Jumper;
  font-size: 2rem;
  text-align: center;
  width: 100%;
  padding: 0.25rem;
  margin: 0 0.8rem;
  margin-bottom: 0.25rem;
  border: none;
  max-width: 400px;
}

.text-style {
  font-weight: 300;
  font-size: 32px;
  white-space: nowrap;
}

@media screen and (max-width: 1246px) {
  .text-style {
    font-size: 16px;
  }
}

.text-style-bold {
  font-weight: 900;
  font-size: 32px;
  white-space: nowrap;
}

@media screen and (max-width: 1246px) {
  .text-style-bold {
    font-size: 16px;
  }
}

.bottom-right-container {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 1246px) {
  .bottom-right-container {
    margin-top: 40px;
    display: flex;
    align-items: center;
  }
}

.paging-div {
  padding: 0.6rem;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  color: #b2ec5d;
  background-color: #252734;
  font-size: 1rem;
  border-radius: 32px;
  cursor: pointer;
}

.paging-div:hover {
  background-color: #b2ec5d !important;
  color: #252734 !important;
}

.paging-div.disabled {
  color: gray;
}

.card-container {
  width: fit-content;
  margin: 0 auto;
}

@media screen and (min-width: 1246px) {
  .container-style {
    min-width: 600px;
  }
}

.list-item {
  font-size: 18px !important;
  text-align: left;
  padding: 0.12rem;
  border: none !important;
}

@media screen and (min-width: 1246px) {
  .min-width {
    min-width: 620px;
  }
}

.desktop-only {
  display: none;
}

.mobile-only {
  display: none;
}

@media screen and (min-width: 1246px) {
  .desktop-only {
    display: flex;
  }
  .card-body {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
    margin: 0 auto;
  }

}

@media screen and (max-width: 1246px) {

  .card-body {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
    margin: 0 auto;
  }
  .mobile-only {
    display: flex;
  }
}

.reportSliderContainer {
  border: 1px solid #252734;
  border-radius: 32px;
  padding: 20px;
}
</style>
